/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Negotiation_Error_CopyInputs */

const en_negotiation_error_copy = /** @type {(inputs: Negotiation_Error_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to copy`)
};

const de_negotiation_error_copy = /** @type {(inputs: Negotiation_Error_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to copy`)
};

const fr_negotiation_error_copy = /** @type {(inputs: Negotiation_Error_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to copy`)
};

const es_negotiation_error_copy = /** @type {(inputs: Negotiation_Error_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to copy`)
};

const it_negotiation_error_copy = /** @type {(inputs: Negotiation_Error_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to copy`)
};

const nl_negotiation_error_copy = /** @type {(inputs: Negotiation_Error_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to copy`)
};

const pl_negotiation_error_copy = /** @type {(inputs: Negotiation_Error_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to copy`)
};

const fi_negotiation_error_copy = /** @type {(inputs: Negotiation_Error_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to copy`)
};

const da_negotiation_error_copy = /** @type {(inputs: Negotiation_Error_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to copy`)
};

const sv_negotiation_error_copy = /** @type {(inputs: Negotiation_Error_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to copy`)
};

/**
* | output |
* | --- |
* | "Failed to copy" |
*
* @param {Negotiation_Error_CopyInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const negotiation_error_copy = /** @type {((inputs?: Negotiation_Error_CopyInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Negotiation_Error_CopyInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_negotiation_error_copy(inputs)
	if (locale === "fr") return fr_negotiation_error_copy(inputs)
	if (locale === "es") return es_negotiation_error_copy(inputs)
	if (locale === "it") return it_negotiation_error_copy(inputs)
	if (locale === "nl") return nl_negotiation_error_copy(inputs)
	if (locale === "pl") return pl_negotiation_error_copy(inputs)
	if (locale === "fi") return fi_negotiation_error_copy(inputs)
	if (locale === "da") return da_negotiation_error_copy(inputs)
	if (locale === "sv") return sv_negotiation_error_copy(inputs)
	return en_negotiation_error_copy(inputs)
});